import React, { useState, useEffect } from 'react';
import { Link,useLocation,useHistory} from 'react-router-dom';
import "../../common.css";
import "../../investorAcademy.css";
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';


const IndexCallExamples = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    const location = useLocation();
    const history = useHistory();

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>
            
            <div id="main" className='warrant-sensitivity Common_warrent call_exampple'>
                <div id="maintable" style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>
                    <div style={{display: 'table-row'}}>
                    <div id="leftbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}} />
                    <div id="maincontainer" style={{display: 'table-cell', width: '100%'}}>
                        <div id="mainnav" className='first_table'>
                        <table style={{width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223'}}>
                            <tbody><tr>
                                <td width="20%" style={{textAlign: 'left', visibility: 'hidden'}}>
                                <table className="hasprev hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td width="33px"><div className="prev left" /></td>
                                        <td>
                                        <div className="prevlbl left">
                                            <div className="prevtitle " style={{textAlign: 'left'}} />
                                            <div className="prevname " style={{textAlign: 'left'}}>Index Expiry - Formula</div>
                                        </div>
                                        </td>
                                    </tr>
                                    </tbody></table>
                                </td>
                                <td width="60%" style={{textAlign: 'center'}}>
                                <div id="pagetitlediv" style={{width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto'}}>
                                    <div id="ptitle" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px'}}>Index calls and puts at expiry</div>
                                    <div id="pname" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px'}}>Call example</div>
                                </div>
                                </td>
                                <td width="20%" style={{textAlign: 'right', visibility: 'hidden'}}>
                                <table className="hasnext  hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td>
                                        <div className="nextlbl right">
                                            <div className="nexttitle " style={{textAlign: 'right'}} />
                                            <div className="nextname " style={{textAlign: 'right'}}>Put example</div>
                                        </div>
                                        </td>
                                        <td width="33px"><div className="next right" /></td>
                                    </tr>
                                    </tbody></table>
                                </td>
                            </tr>
                            </tbody></table>
                        </div>
                        <div id="maincontent" style={{marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px'}}>
                        <div id="mainscroll" style={{height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px'}}>
                            <div id="mainscrollcontent">
                            <style dangerouslySetInnerHTML={{__html: "\n/*            .exampleholder .examplebox{\n                display:inline-block;\n                border:4px solid #404040;\n                background-color: #000000;\n                padding:16px;\n                width: 100%\n            }*/\n            .exampleholder .examplebox .col{\n  line-height: 1.42857143;\n                float:left;\n                width:100%;\n                margin:2px 0;\n            }\n            .exampleholder .examplebox  .lbl,\n            .exampleholder .examplebox  .val{\n                float:left;\n            }\n            .exampleholder .examplebox  .lbl{\n                color:#8F8F8F;\n            }\n            .formulaholder p span.leqt{\n                color:#FFDA44;\n            }\n            .imgholder{\n                margin-bottom:16px;\n            }\n            .imgholder img{\n                max-width: 754px; \n            }\n        " }} />
                            <div className="contentbox">
                                <div className="exampleholder" style={{paddingBottom: "14px"}}> 
                                <div className="examplebox">
                                    <div className="col"><div className="lbl">Exercise Level of HSI Call Warrant:&nbsp;&nbsp;</div><div className="val">20,000</div></div>
                                    <div className="col"><div className="lbl">Exercise Ratio of HSI Call Warrant:&nbsp;&nbsp;</div><div className="val">1,000 warrants per share</div></div>
                                    <div className="col"><div className="lbl">Settlement Level of HSI:&nbsp;&nbsp;</div><div className="val">21,000</div></div>
                                    <div className="col"><div className="lbl">FX Rate:&nbsp;&nbsp;</div><div className="val">0.40 (MYR per HKD)</div></div>
                                </div>
                                </div>
                                <p>
                                Since the settlement price of HSI share is higher than the exercise price of the call warrant, the warrant expires ‘in-the-money’.
                                </p>
                                <div className="formulaholder">
                                <div className="formulabox">
                                    <div className="leqt">
                                    <table cellSpacing={0} cellPadding={0}>
                                        <tbody>
                                        <tr>
                                            <td className="hltxt" style={{height: '39px'}}>    
                                            Cash Settlement Amount:
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    </div>   
                                    <div className="reqt">
                                    <table className="fraction" cellSpacing={0} cellPadding={0}>
                                        <tbody>
                                        <tr><td>(21,000 - 20,000)</td><td rowSpan={2}>&nbsp;x 0.4</td></tr>
                                        <tr><td className="upper_line">1,000</td></tr>
                                        </tbody>  
                                    </table>
                                    </div>
                                    <div className="reqt">
                                    <table cellSpacing={0} cellPadding={0}>
                                        <tbody>
                                        <tr><td style={{height: '39px'}}> = <b>MYR 0.40 per warrant</b></td></tr>
                                        </tbody>  
                                    </table>
                                    </div>
                                </div>
                                </div>
                                <p>
                                If the settlement price of the HSI futures is same as the exercise price of MYR 1.00 or less, the warrant expires out-of-the-money and there will be no cash settlement.
                                </p>
                            </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                        </div>
                        </div>
                    </div>
                    <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                    </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
                >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                    display: "table",
                    width: "100%",
                    textAlign: "center",
                    color: "#8F8F8F",
                    fontSize: "11px",
                    lineHeight: "40px",
                    }}
                >
                 <div className='copyright_sec'>
                 Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                    reserved.
                    </div> 
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    right: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasnext"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td>
                            <div className="nextlbl right">
                            <div
                                className="nextname "
                                style={{ textAlign: "right", fontSize: "15px" }}
                            >
                                <Link to="/edu/index-calls/put-example">
                                       <span className="prevname ">Put example</span>
                            </Link>
                            </div>
                            </div>
                        </td>
                        <td width="33px">
                        <Link to="/edu/index-calls/put-example">
                            <div className="next right" />
                        </Link>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    left: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasprev"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td width="33px">
                        <Link to="/edu/index-calls/index-expiry">
                            <div className="prev left" />
                            </Link>
                        </td>
                        <td>
                            <div className="prevlbl left">
                            <div
                                className="prevname "
                                style={{ textAlign: "left", fontSize: "15px" }}
                            >
                                	<Link to="/edu/index-calls/index-expiry">
                                       <span className="prevname "> Index Expiry - Formula</span>
                            </Link>
                            </div>
                            </div>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
            {/* <div className="dbtn dbtn-seminarbtn">
            <Link
                    className="seminarbtn"
                    to="/education/seminar"
                    >
                    <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history}/>
            </div>

        </div>
      );
}
export default IndexCallExamples;